export const MODE_CALCUL_TYPE_SEJOUR = [
    { id: 0, description: 'Global' },
    { id: 1, description: 'Jours' },
    { id: 2, description: 'Personnes' },
    { id: 3, description: 'Jours/Personnes' },
]